import React, { Component } from 'react';
import { Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FieldHelpIcon } from '../icon/FieldHelpIcon';
import { helpModalControl } from '../modals/HelpModalControl';

class LabeledTextAreaUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.id = `i${uuid()}`;
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      model, label, readOnly, rows, helpModalId,
    } = this.props;
    return (
      <div className="form-group">
        <label htmlFor={this.id}>
          <div className="haz-help-icon-inline">
            <span>{label}</span>
            {helpModalId && <span><FieldHelpIcon handleClick={this.handleHelpClick} /></span>}
          </div>
        </label>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Control.textarea
          model={model}
          id={this.id}
          mapProps={{
            readOnly,
            rows,
            className: ({ fieldValue }) => classnames({ 'form-control': true, 'is-invalid': !fieldValue.valid }),
          }}
        />
        <Errors
          model={model}
          component="div"
          wrapper={({ children }) => <div className="invalid-feedback">{children}</div>}
        />
      </div>
    );
  }
}

LabeledTextAreaUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  rows: PropTypes.number,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
};

LabeledTextAreaUnwrapped.defaultProps = {
  readOnly: false,
  rows: 5,
  helpModalId: '',
};

export const LabeledTextArea = helpModalControl(LabeledTextAreaUnwrapped);
